module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute pin-l pin-t pin-b pin-r z-10 m-0"
  }, [_c('l-map', {
    ref: "map",
    attrs: {
      "zoom": _vm.zoomLevel,
      "min-zoom": 3,
      "max-zoom": 13,
      "center": _vm.mapCenter
    },
    on: {
      "click": _vm.mapClicked,
      "move": function($event) {
        _vm.$emit('mapMoved')
      }
    }
  }, [_c('l-tile-layer', {
    attrs: {
      "url": _vm.mapUrl
    }
  }), _vm._v(" "), _c('l-marker-cluster', _vm._l((_vm.markers), function(p) {
    return (_vm.showMarkers && p.latlng) ? _c('l-marker', {
      key: p.id,
      attrs: {
        "lat-lng": p.latlng,
        "draggable": false
      },
      on: {
        "click": function($event) {
          _vm.$emit('markerClicked', p)
        }
      }
    }) : _vm._e()
  })), _vm._v(" "), (_vm.showNewPoint) ? _c('l-marker', {
    attrs: {
      "lat-lng": _vm.newPoint,
      "draggable": true
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d10b71b4","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/StudentMap.vue
// module id = 175
// module chunks = 0